module.exports = __webpack_public_path__ + "static/img/ldr.5c08db8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brands/ldr.jpg
// module id = 223
// module chunks = 1